import { DatosReporte } from '../core/reporte';

export interface FormatoReportePrevired extends DatosReporte {
    anio: boolean;
    mes?: boolean;
}

const REPORTE_PAGOS_NOMINAS: FormatoReportePrevired = {
    tituloReporte: 'Pagos de nóminas',

    subtituloReporte: 'Detalle de pagos y cotizaciones previsionales informados por Previred.',

    icono: 'pi pi-wallet',

    tablas: [
        {
            datos: 'pagosNominas',

            titulo: 'Pagos de nóminas',

            subtitulo: 'Cotizaciones previsionales agrupadas por mes.',

            columnas: [
                {
                    nombre: 'nombreMes',
                    titulo: 'Mes',
                    clase: 'w-1/4'
                },
                {
                    nombre: 'nominas',
                    titulo: 'Nóminas',
                    clase: 'w-1/4'
                },
                {
                    nombre: 'instituciones',
                    titulo: 'Instituciones',

                    subTabla: {
                        datos: 'instituciones',

                        noData: 'No existen instituciones registradas para este mes.',

                        columnas: [
                            {
                                nombre: 'institucion',
                                titulo: 'Institución'
                            },
                            {
                                nombre: 'total',
                                titulo: 'Total',
                                formato: 'moneda',
                                clase: 'text-right'
                            }
                        ]
                    }
                }
            ]
        }
    ],

    anio: true
};

export const PREVIRED_TCP: FormatoReportePrevired = {
    tituloReporte: 'Trabajador Casa Particular',

    subtituloReporte: '',

    icono: 'pi pi-wallet',

    tablas: [
        {
            datos: 'registros',
            titulo: 'Trabajador Casa Particular',

            subtitulo: '',

            columnas: [
                { nombre: 'mes', titulo: 'Mes' },
                { nombre: 'nombre', titulo: 'Nombre' },
                { nombre: 'rut', titulo: 'Rut' },
                {
                    nombre: 'plantillas',
                    titulo: 'Instituciones',
                    subTabla: {
                        datos: 'plantillas',
                        noData: 'No existen instituciones para este trabajador.',
                        columnas: [
                            {
                                nombre: 'institucion',
                                titulo: 'Institución'
                            },
                            {
                                nombre: 'total',
                                titulo: 'Total',
                                formato: 'moneda',
                                clase: 'text-right'
                            }
                        ]
                    }
                }
            ]
        }
    ],

    anio: true
};

export const PREVIRED_REPORTES_DATOS = {
    pagosnominas: REPORTE_PAGOS_NOMINAS,
    previred_tcp: PREVIRED_TCP
} satisfies Record<string, FormatoReportePrevired>;

export type TipoReportePrevired = keyof typeof PREVIRED_REPORTES_DATOS;
